import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Input from '../elements/Input';
import Button from '../elements/Button';
import { useTranslation } from '../../i18n/LanguageProvider';

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

const CONTACT_EMAIL = 'contato@algorcode.com.br';

const ContactFormSection = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const { t } = useTranslation();

  const outerClasses = classNames(
    'contact-form section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'contact-form-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });

  const [feedback, setFeedback] = useState('');

  const updateField = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
    if (feedback) {
      setFeedback('');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const { name, email, company, phone, message } = formValues;
    const subject = `${t('contactForm.subjectPrefix')} - ${name || t('contactForm.fallbackProject')}`;
    const bodyLines = [
      `${t('contactForm.fields.name.label')}: ${name}`,
      `${t('contactForm.fields.email.label')}: ${email}`,
      phone ? `${t('contactForm.fields.phone.label')}: ${phone}` : null,
      company ? `${t('contactForm.fields.company.label')}: ${company}` : null,
      '',
      `${t('contactForm.fields.message.label')}:`,
      message
    ].filter(Boolean);
    const mailtoLink = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(bodyLines.join('\n'))}`;
    window.location.href = mailtoLink;
    setFeedback(t('contactForm.feedback', { email: CONTACT_EMAIL }));
  };

  return (
    <section
      {...props}
      className={outerClasses}
      id="form-contato"
    >
      <div className="container">
        <div className={innerClasses}>
          <div className="section-header center-content">
            <div className="container-xs">
              <h2 className="mt-0">{t('contactForm.header.title')}</h2>
              <p className="m-0">
                {t('contactForm.header.description')}
              </p>
            </div>
          </div>
          <form className="contact-form-fields" onSubmit={handleSubmit} noValidate>
            <div className="form-grid">
              <Input
                id="contact-name"
                type="text"
                name="name"
                label={t('contactForm.fields.name.label')}
                placeholder={t('contactForm.fields.name.placeholder')}
                required
                value={formValues.name}
                onChange={updateField}
              />
              <Input
                id="contact-email"
                type="email"
                name="email"
                label={t('contactForm.fields.email.label')}
                placeholder={t('contactForm.fields.email.placeholder')}
                required
                value={formValues.email}
                onChange={updateField}
              />
            </div>
            <div className="form-grid">
              <Input
                id="contact-company"
                type="text"
                name="company"
                label={t('contactForm.fields.company.label')}
                placeholder={t('contactForm.fields.company.placeholder')}
                value={formValues.company}
                onChange={updateField}
              />
              <Input
                id="contact-phone"
                type="tel"
                name="phone"
                label={t('contactForm.fields.phone.label')}
                placeholder={t('contactForm.fields.phone.placeholder')}
                value={formValues.phone}
                onChange={updateField}
              />
            </div>
            <Input
              id="contact-message"
              type="textarea"
              name="message"
              label={t('contactForm.fields.message.label')}
              placeholder={t('contactForm.fields.message.placeholder')}
              rows={6}
              required
              value={formValues.message}
              onChange={updateField}
            />
            <div className="form-submit">
              <Button type="submit" color="primary" wideMobile>
                {t('contactForm.submit')}
              </Button>
            </div>
            {feedback && (
              <div className="form-feedback text-sm text-color-high">
                {feedback}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

ContactFormSection.propTypes = propTypes;
ContactFormSection.defaultProps = defaultProps;

export default ContactFormSection;
